import { render, staticRenderFns } from "./TransactionEKYCOTPNew.vue?vue&type=template&id=37b2912f&"
import script from "./TransactionEKYCOTPNew.vue?vue&type=script&lang=js&"
export * from "./TransactionEKYCOTPNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports